module.exports = __webpack_public_path__ + "img/Ghostbusters Bingo.6cd2a986.jpeg";